import React, { useContext, useState } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import ProductForm from './ProductForm';
import { apiFetch } from '../utils/api';

const AddProduct = () => {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  if (!user || user.role !== 'admin') {
    navigate('/');
    return null;
  }

  const handleSubmit = async (data) => {
    setLoading(true);
    setMessage(null);

    try {
      const res = await apiFetch('/api/products', {
        method: 'POST',
        body: data,
      });

      const responseData = await res.json();

      if (res.ok) {
        setMessage({ type: 'success', text: 'Product created successfully!' });
        setTimeout(() => navigate('/admin/products'), 1500);
      } else {
        setMessage({ type: 'error', text: responseData.message || 'Error creating product' });
      }
    } catch (error) {
      console.error(error);
      setMessage({ type: 'error', text: 'Something went wrong' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProductForm
      isEdit={false}
      onSubmit={handleSubmit}
      loading={loading}
      message={message}
    />
  );
};

export default AddProduct;
